import React, { useState } from "react";
import { ActionPanel } from "components/panel";
import { Button } from "components/buttons";
import { LicenceCheckingService } from "services";
import { NotificationToaster } from "components/notifications";
import { Intent } from "@blueprintjs/core";
import PropTypes from "prop-types";

export function AwaitingDocumentsPanel({ checkData, reloadCheck }) {
    const [isSaving, setIsSaving] = useState(false);

    function handleInvalidInsurance() {
        LicenceCheckingService.resendInsuranceDetailsReminder(checkData?.id)
            .then(
                () => {
                    NotificationToaster.show(
                        Intent.SUCCESS,
                        "Insurance details reminder email resent successfully."
                    );
                    reloadCheck();
                },
                (err) => {
                    const validationError = 400;
    
                    if (err?.response?.status === validationError && err.response.data != null) {
                        NotificationToaster.show(
                            Intent.WARNING,
                            err.response.data
                        );
                        return;
                    }
                
                    NotificationToaster.show(
                        Intent.DANGER,
                        "Unable to resend insurance details reminder email. Please try again later."
                    );
                }
            )
            .catch(() => {
                NotificationToaster.show(
                    Intent.DANGER,
                    "Unable to resend insurance details reminder email. Please try again later."
                );
            })
            .finally(() => {
                setIsSaving(false);
            });
    }

    return (
        <div className="spacer-top">
            <ActionPanel intent="warning" title="Awaiting Documents">
                <p className="spacer-bottom">
                    The Grey Fleet Check is awaiting insurance documents to be
                    uploaded. To send a reminder email please click the button
                    below.
                </p>
                <Button
                    id="awaiting-documents-resend-email"
                    onClick={handleInvalidInsurance}
                    text={"Resend Email"}
                    icon="reset"
                    intent="Primary"
                    disabled={isSaving}
                />
            </ActionPanel>
        </div>
    );
}

AwaitingDocumentsPanel.propTypes = {
    checkData: PropTypes.object.isRequired,
    reloadCheck: PropTypes.func.isRequired,
};
